/* eslint-disable no-console, import/prefer-default-export */
import { forgotPassword } from './account-api';

const submitForm = (data, callbacks) => {
  forgotPassword(data, callbacks);
};

export {
  submitForm,
};
/* eslint-enable no-console, import/prefer-default-export */
